import React, { FC } from 'react';
import { useCampoFormularioProps } from 'service/restricao/useCampoFormularioProps/useCampoFormularioProps';

interface ExibicaoCondicionalProps {
  name: string;
}

export const ExibicaoCondicional: FC<ExibicaoCondicionalProps> = (props) => {
  const restricoesProps = useCampoFormularioProps(props.name);

  if (restricoesProps.hidden)
    return <></>
  
  return <>{props.children}</>
}
